import { registerPlugin } from '@capacitor/core';

export namespace ExactAlarmPermissionPlugin {
  export interface IExactAlarmPermissionPlugin {
    hasPermission(): Promise<HasPermissionResponse>;
    requestPermission(): Promise<RequestPermissionResponse>;
  }

  export type HasPermissionResponse = {
    hasPermission: boolean;
  };

  export type RequestPermissionResponse = {
    granted: boolean;
  };
}

export const ExactAlarmPermission = registerPlugin<ExactAlarmPermissionPlugin.IExactAlarmPermissionPlugin>('ExactAlarmPermissionPlugin');
